import { formatNumber } from '../../lib/formatters.js';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 深掘り分析タブの汎用テーブル fallback。専用コンポーネントが定義されていない analysisType でも、レスポンスの全カラムをそのまま表示できるようにする。
 * @graph-connects formatNumber [calls] 数値フォーマット
 */
export function GenericDetailsTable({ data }: { data: Record<string, unknown>[] }) {
  if (data.length === 0) {
    return (
      <div className="card">
        <p className="text-sm text-[var(--color-text-muted)] text-center py-8">
          データがありません
        </p>
      </div>
    );
  }

  const columns = Object.keys(data[0]);

  return (
    <div className="card animate-fade-in-up">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[var(--color-border)]">
              {columns.map((col) => (
                <th
                  key={col}
                  className="text-left py-2 px-3 text-xs font-medium text-[var(--color-text-muted)]"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr
                key={idx}
                className="border-b border-[var(--color-border)] last:border-b-0 hover:bg-[var(--color-bg-hover)]"
              >
                {columns.map((col) => (
                  <td key={col} className="py-2 px-3 text-[var(--color-text-primary)]">
                    {typeof row[col] === 'number'
                      ? formatNumber(row[col])
                      : row[col] != null
                        ? String(row[col] as string | number | boolean)
                        : ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
